export interface SelectedCompany {
  id: string;
  tenantId: string;
  name: string;
  /** ISO 4217 code, e.g. "ZAR". Optional: selections stored before currency support lack it. */
  currencyCode?: string;
  currencySymbol?: string;
}

export const SELECTED_COMPANY_KEY = 'selectedCompany';
